const handlers = ({ axios }) => ({
    get :   async () => await axios.get( `https://pdtclientsolutions.com/crm-public/api/lines/bussiness` ) ,
})


export default handlers